import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function UserDetails() {
  const { userId } = useParams();

  const token = localStorage.getItem("adminToken");

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUser();
  }, []);

  async function loadUser() {
    try {
      const res = await fetch("/api/admin/details/" + userId, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      const json = await res.json();

      if (json.success) {
        setUser(json.user);
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }

  async function updateBalance(field, action) {
    const amount = prompt(`Enter amount to ${action} in ${field}`);

    if (!amount) return;

    const res = await fetch("/api/admin/update-user-balance", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        userId: user.userId,
        field,
        amount,
        action,
      }),
    });

    const data = await res.json();

    alert(data.message || "Done");

    if (data.success) {
      loadUser();
    }
  }

  if (loading) {
    return <h2 style={{ padding: 30 }}>Loading...</h2>;
  }

  if (!user) {
    return <h2 style={{ padding: 30 }}>User Not Found</h2>;
  }

  const row = (label, value) => (
    <tr>
      <td style={{ width: 260 }}>
        <b>{label}</b>
      </td>
      <td>{value || "-"}</td>
    </tr>
  );

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f4f6f9",
      }}
    >
      <Sidebar />

      <div style={{ flex: 1 }}>
        <Header />

        <div style={{ padding: 25 }}>
          <h2>User Details</h2>

          <div
            style={{
              background: "#fff",
              padding: 25,
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,.08)",
            }}
          >
            <table
              width="100%"
              cellPadding="10"
              style={{
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                {row("User ID", user.userId)}
                {row("Name", user.name)}
                {row("Email", user.email)}
                {row("Phone", user.phone)}
                {row("Password", user.password)}
                {row("Sponsor ID", user.sponsorId)}
                {row("Deposit Address", user.depositAddress)}
                {row("Withdrawal Address", user.withdrawalAddress)}

                {row(
                  "Wallet Balance",
                  Number(user.walletBalance || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Earning Balance",
                  Number(user.earningBalance || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Available Balance",
                  Number(user.availableBalance || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Today Earnings",
                  Number(user.todayEarnings || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Yesterday Earnings",
                  Number(user.yesterdayEarnings || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Level Income",
                  Number(user.levelIncome || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Team Income",
                  Number(user.teamIncome || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Total Earned",
                  Number(user.totalEarned || 0).toFixed(4) + " USDT"
                )}

                {row(
                  "Contract Value",
                  Number(user.contractValue || 0).toFixed(4) + " USDT"
                )}

                <tr>
                  <td>
                    <b>Status</b>
                  </td>
                  <td>
                    <span
                      style={{
                        color: user.blocked ? "red" : "green",
                        fontWeight: "bold",
                      }}
                    >
                      {user.blocked ? "Blocked" : "Active"}
                    </span>
                  </td>
                </tr>

                {row(
                  "Register Date",
                  user.createdAt
                    ? new Date(user.createdAt).toLocaleString()
                    : "-"
                )}
              </tbody>
            </table>

            <div
              style={{
                marginTop: 25,
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={() => updateBalance("walletBalance", "add")}
                style={btn("#16a34a")}
              >
                Add Wallet Balance
              </button>

              <button
                onClick={() => updateBalance("walletBalance", "remove")}
                style={btn("#dc2626")}
              >
                Remove Wallet Balance
              </button>

              <button
                onClick={() => updateBalance("earningBalance", "add")}
                style={btn("#2563eb")}
              >
                Add Earning Balance
              </button>

              <button
                onClick={() => updateBalance("earningBalance", "remove")}
                style={btn("#ea580c")}
              >
                Remove Earning Balance
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function btn(bg) {
  return {
    padding: "10px 16px",
    background: bg,
    color: "#fff",
    border: 0,
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: "bold",
  };
}
